import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthField } from '../AuthField';
import type { IMfaCodeStepProps } from './IMfaCodeStepProps';
import { mfaCodeOf } from './mfaCode';
import './mfa.css';

/**
 * Крок «Двоетапна перевірка» (обліковий запис з увімкненим застосунком автентифікації; сервер відповів mfa_required) у стилі екрана входу:
 * заголовок і пояснення з e-mail, поле 6-значного коду (цифрова клавіатура, автозаповнення одноразового коду), помилка, «Підтвердити»
 * і «← Назад до входу».
 */
export function MfaCodeStep({ email, busy, error, onSubmit, onEdit, onBack }: IMfaCodeStepProps) {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!busy) onSubmit(code);
  };
  return (
    <form className="au__form" onSubmit={submit} noValidate>
      <div className="au__head">
        <h1>{t('auth.mfa.codeTitle')}</h1>
        <div className="au__sub">{t('auth.mfa.codeSub', { email })}</div>
      </div>
      <AuthField label={t('auth.mfaCode')} type="text" value={code} placeholder={t('auth.mfaCodePh')} autoComplete="one-time-code" inputMode="numeric"
        autoFocus onChange={(v) => { setCode(mfaCodeOf(v)); onEdit(); }} />
      {error && <div className="au__error" role="alert">{error}</div>}
      <button type="submit" className="au__submit" disabled={busy}>{t('auth.mfa.verify')}</button>
      <div className="au__switch"><button type="button" className="au__linkbtn" onClick={onBack}>{t('auth.mfa.back')}</button></div>
    </form>
  );
}
